// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'


function calculateForm1(){
  var hoogte = $('.acf-field').find("[data-name='form1_hoogte']").find(':input').val();
  var breedte = $('.acf-field').find("[data-name='form1_breedte']").find(':input').val();
  var aantal_regels = $('.acf-field').find("[data-name='form1_regels']").find(':input').val();
  var kwaliteit = $('.acf-field').find("[data-name='form1_kwaliteit']").find('label.selected > input[type="radio"]').val();

  var stuwdruk = $('.acf-field').find("[data-name='form1_stuwdruk']").find(':input').val();
  var zone = $('.acf-field').find("[data-name='form1_zone']").find('label.selected > input[type="radio"]').val();

  var overspanning = $('.acf-field').find("[data-name='form1_overspanning']").find(':input').val();
  var belastinglinksonder = $('.acf-field').find("[data-name='form1_belastinglinksonder']").find(':input').val();
  var belastingrechtsboven = $('.acf-field').find("[data-name='form1_belastingrechtsboven']").find(':input').val();
  var doorbuiging = $('.acf-field').find("[data-name='form1_doorbuiging']").find('label.selected > input[type="radio"]').val();

  var nails = $('.acf-field').find("[data-name='form1_nails']").find('label.selected > input[type="radio"]').val();
  var nails_hulp = $('.acf-field').find("[data-name='form1_nails_hulp']").find('label.selected > input[type="radio"]').val();

  var aantal_hoeken = $('.acf-field').find("[data-name='form1_corner_amount']").find(':input').val();

  $.ajax({
    url: '/wp-admin/admin-ajax.php',
    data: {
      action: 'form1Calculate',
      hoogte: hoogte,
      breedte: breedte,
      aantal_regels: aantal_regels,
      kwaliteit: kwaliteit,
      stuwdruk: stuwdruk,
      zone: zone,
      overspanning: overspanning,
      belastinglinksonder: belastinglinksonder,
      belastingrechtsboven: belastingrechtsboven,
      doorbuiging: doorbuiging,
      nails: nails,
      nails_hulp: nails_hulp,
      aantal_hoeken: aantal_hoeken,
    },
    method: 'POST',
    success: function (html) {
      $('.calculation-result').html(html);
      $('#form1Calc .acf-form-submit input[type="submit"]').prop("disabled", false).addClass('active');
    }
  });
}

$(document).ready(function(){

  $('#form1Calc .acf-form-submit input[type="submit"]').prop("disabled", true);
  $('#form1Calc .acf-form-submit').append('<input type="submit" id="calculate_form1" value="Berekenen" class="calculate-btn btn btn--primary"/>');

  $('#calculate_form1').click(function(e){
    e.preventDefault();
    calculateForm1();
  });

});



// WEBPACK FOOTER //
// ./resources/assets/js/form1.js